module.exports = __webpack_public_path__ + "img/Mask Group2@2x.95407e91.png";